import { SupportedLanguage, isLearnable } from '../../api/globalSettings';

// Languages offered in the learning picker: learnable ones, minus Russian and
// Ukrainian (offered as native/interface languages only here).
export const isOfferedForLearning = (lang: SupportedLanguage): boolean =>
    isLearnable(lang) && lang.code !== 'ru' && lang.code !== 'uk';

// The learning language to preselect for a native language: English for
// anyone whose native language is known and isn't English. In 2026-10, 16/16
// Spanish, 12/15 Polish, 10/13 French, 14/20 Russian and 8/13 German speakers
// who finished onboarding learn English; English speakers spread over five
// languages, so they get no preselection. Step 1 was where most users quit.
// Mobile: suggestLearningLanguage in onboarding/helpers.ts.
export function suggestLearningLanguage(native: string, languages: SupportedLanguage[]): string {
    if (!native || native === 'en') return '';
    return languages.some(l => l.code === 'en' && isOfferedForLearning(l)) ? 'en' : '';
}
